import React, { memo } from "react";
import { CardNotification, Heading, Text } from "@foris/avocado-suite";
import {
  AdaptedGroup,
  GroupEditionErrors,
  HardGroupEditionErrors,
  SoftGroupEditionErrors,
} from "../../models";
import messageByGroupEditionError from "../../utils/messageByGroupEditionError";
import css from "./bottomErrors.module.scss";

interface Props {
  errorsByGroupId: Record<AdaptedGroup["id"], GroupEditionErrors>;
  capacityError: {
    display: boolean;
    group: AdaptedGroup;
  };
  groupsById: Record<AdaptedGroup["id"], AdaptedGroup>;
}

const BottomErrors: React.FC<Props> = ({ errorsByGroupId, capacityError, groupsById }) => {
  const title = () => {
    const length = Object.keys(errorsByGroupId)?.length + (capacityError?.display ? 1 : 0);
    return length === 1 ? "1 Grupo con errores" : `${length} Grupos con errores`;
  };

  return (
    <CardNotification className={css.errors} state="error" title={title()} outlined>
      <div className={css.groups}>
        {capacityError?.display && (
          <>
            <Heading
              type="h4"
              className={css.error_title}
            >{`Grupo ${capacityError?.group?.code}`}</Heading>
            <Text className={css.error_message}>La suma de los cupos sobrepasa la capacidad</Text>
          </>
        )}

        {Object.keys(errorsByGroupId)?.map((groupId: string) => {
          const errors = errorsByGroupId[groupId];
          return (
            <div key={groupId}>
              <Heading
                type="h4"
                className={css.error_title}
              >{`Grupo ${groupsById[groupId]?.code}`}</Heading>

              {Object.keys(errors)?.map(error => (
                <Text key={`${groupId}-${error}`} className={css.error_message}>
                  {
                    messageByGroupEditionError(
                      error as keyof SoftGroupEditionErrors | keyof HardGroupEditionErrors,
                    )?.verbose
                  }
                </Text>
              ))}
            </div>
          );
        })}
      </div>
    </CardNotification>
  );
};

export default memo(BottomErrors);
